import clsx from "clsx";
import parse from "html-react-parser";
import { useState } from "react";

import EmbeddedForm from "@components/EmbeddedForm";

const GlossaryLayoutNewsletterForm = ({
	formHeading,
	formDescription,
	form,
	formData,
	successMessage,
}) => {
	const [isFormSuccessfullySubmitted, setIsFormSuccessfullySubmitted] =
		useState(false);

	const handleFormSuccess = () => {
		setIsFormSuccessfullySubmitted(true);
	};

	return (
		<>
			<div
				className={clsx(
					"GlossaryLayout__formContainer",
					"h-full",
					"bg-green-03 text-black-01",
					"p-4",
          "pb-8"
				)}
			>
				<h2 className={clsx("GlossaryLayout__formHeading", "mb-1", "text-4xl", "leading-[48px]")}>
					Get the Latest Insights
				</h2>
        
        {!!formDescription && (
          <div className={clsx("GlossaryLayout__formDescription", "mb-7.5")}>
            {parse(formDescription)}
          </div>
        )}
				{!isFormSuccessfullySubmitted && (
					<div className={clsx("GlossaryLayout__embeddedForm")}>
						<EmbeddedForm
							form={form}
							formData={formData}
							onSuccess={handleFormSuccess}
							transparentInputs
							overrideButtonText={"Subscribe"}
							darkMode
              usePlaceholders={true}
              buttonBackgroundColor={"rgb(104, 99, 242)"}
						/>
					</div>
				)}
				{isFormSuccessfullySubmitted && !!successMessage && (
					<div className={clsx("GlossaryLayout__formSuccessMessage", "mb-7.5")}>
						{parse(successMessage)}
					</div>
				)}
			</div>
		</>
	);
};

export default GlossaryLayoutNewsletterForm;
